export default "__VITE_ASSET__Sd81S6QV__"